import { useVariant } from '../context/VariantContext';

export default function Compare() {
  const { compare } = useVariant();
  if (!compare) return null;

  return (
    <section className="lp__compare" id="compare">
      <p className="lp__compare-en">{compare.en}</p>
      <h2 className="lp__compare-heading">{compare.heading}</h2>
      <div className="lp__compare-table-wrap">
        <table className="lp__compare-table">
          <thead>
            <tr>
              <th className="lp__compare-table__header"></th>
              <th className="lp__compare-table__header lp__compare-table__header--tappu">たっぷ</th>
              <th className="lp__compare-table__header">ロボットA</th>
              <th className="lp__compare-table__header">ロボットB</th>
            </tr>
          </thead>
          <tbody>
            {compare.rows.map((row) => (
              <tr key={row.label} className="lp__compare-table__row">
                <td className="lp__compare-table__label">{row.label}</td>
                <td className="lp__compare-table__cell lp__compare-table__cell--tappu">{row.tappu}</td>
                <td className="lp__compare-table__cell">{row.robotA}</td>
                <td className="lp__compare-table__cell">{row.robotB}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="lp__compare-footnote">{compare.footnote}</p>
    </section>
  );
}
